import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { buildUrl } from 'submodules/engine-common/util';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { httpOptions } from 'src/app/submodules/angular-common/http-util';
import { Observable } from 'rxjs';
import { LocaleDataService } from 'src/app/submodules/angular-common/locale-data.service';

@Injectable()
export class VerifyContactService {

    constructor(
        private _injector:Injector,
        private _httpClient: HttpClient,
    ) { }


    requireEmailConfirmationOtpObs(): Observable<any> {
        return this._httpClient.post(
            buildUrl(
                this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["secure","v1","require-email-confirmation-otp"]
            ),
            {
                'lc': this._injector.get(LocaleDataService).locale
            },
            httpOptions());
    }

    requireEmailConfirmationOtp = async (): Promise<any> => this.requireEmailConfirmationOtpObs().toPromise()


    confirmEmailAddressObs(otp: string): Observable<any> {
        return this._httpClient.post(
            buildUrl(
                this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["secure","v1","confirm-email-address"]
            ),
            {
                'otp': otp
            },
            httpOptions());
    }

    confirmEmailAddress = async (otp: string): Promise<any> => this.confirmEmailAddressObs(otp).toPromise()


    requireMobileNumberConfirmationOtpObs(): Observable<any> {
        return this._httpClient.post(
            buildUrl(
                this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["secure","v1","require-mobile-number-confirmation-otp"]
            ),
            {
                'lc':  this._injector.get(LocaleDataService).locale
            },
            httpOptions());
    }

    requireMobileNumberConfirmationOtp = async (): Promise<any> => this.requireMobileNumberConfirmationOtpObs().toPromise()

    confirmMobileNumberObs(otp: string): Observable<any> {
        return this._httpClient.post(
            buildUrl(
                this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["secure","v1","confirm-mobile-number"]
            ),
            {
                'otp': otp
            },
            httpOptions());
    }

    confirmMobileNumber = async (otp: string): Promise<any> => this.confirmMobileNumberObs(otp).toPromise()
}



    